// extracted by mini-css-extract-plugin
export default {"accountBreadcrumbs":"si-z","hideOnMobile":"ti-z"};